var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sale-info" }, [
    _c("div", { staticClass: "flexbox gap-5" }, [
      _c(
        "div",
        { staticClass: "tag", class: { "has-entry": _vm.sale.hasEntry } },
        [_vm._v(_vm._s(_vm.getEntryStatus(_vm.sale)))]
      ),
      _vm._v(" "),
      _vm.sale.recommend
        ? _c("div", { staticClass: "tag recommend" }, [_vm._v("おすすめ")])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "tag mall",
        style: {
          backgroundColor: _vm.sale.mall.color,
          borderColor: _vm.sale.mall.color
        }
      },
      [_vm._v(_vm._s(_vm.sale.mall.name))]
    ),
    _vm._v(" "),
    _c("img", {
      staticClass: "sale-banner",
      attrs: { src: _vm.sale.bannerUrl }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "flexbox gap-5" }, [
      _c(
        "div",
        {
          staticClass: "tag",
          class: { premium: _vm.sale.categoryName === "プレミアム" }
        },
        [_vm._v(_vm._s(_vm.sale.categoryName))]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "tag",
          class: {
            deadline: _vm.calcDeadline(_vm.sale.applicationPeriodTo) <= 3
          }
        },
        [
          _vm._v(
            _vm._s(
              "締切まで" + _vm.calcDeadline(_vm.sale.applicationPeriodTo) + "日"
            )
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61743de7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61743de7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/sale/components/SaleInfo.vue
// module id = null
// module chunks = 